/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
export const navigate = (to: string) => {
  if (window.location.pathname + window.location.search === to) {
    return;
  }

  window.history.pushState({}, '', to);
  window.dispatchEvent(new PopStateEvent('popstate'));
};
